import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9f8f8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Nenhuma matéria estudada")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createBlock(_component_q_item_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, { class: "no-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, {
                class: "text-h6",
                "data-cy": "material-title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.stringLimit(_ctx.tree.subject, 40)), 1),
                  (_ctx.stringLimit(_ctx.tree.subject, 50) !== _ctx.tree.subject)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 0,
                        class: _normalizeClass(["text-body2", "bg-primary"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Disciplina: " + _toDisplayString(_ctx.tree.subject), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_label, { caption: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getTotalMaterial()) + " Materiais", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(["animate", _ctx.expanded && "rotate-180"]),
                name: "expand_more"
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_linear_progress, {
        class: "q-mt-md",
        value: _ctx.getPercentage() / 100,
        size: "6px",
        color: "green",
        rounded: ""
      }, null, 8, ["value"]),
      _createVNode(_component_q_item, { class: "no-padding" }, {
        default: _withCtx(() => [
          (_ctx.getTotalStudied())
            ? (_openBlock(), _createBlock(_component_q_item_section, {
                key: 0,
                side: "",
                "data-cy": "study-material"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatCountMaterials), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_item_section, {
                key: 1,
                side: "",
                "data-cy": "no-study-material"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })),
          _createVNode(_component_q_item_section),
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_badge, { color: "grey" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getPercentage()) + "%", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}